<div class="container">
    <pdf-viewer [src]="pdfSource" [original-size]="false">
    </pdf-viewer>
    <div class="buttons">
        <button [autofocus]="true" class="btn btn-default btn-ok" (click)="goToStep2()">Ok</button>
    </div>
</div>
